import { Stack } from '../../../../../design-system/stack/stack';
import { cn } from '../../../../../utils/cn';

type StatCardProps = {
  label: string;
  value: string | number;
  className?: string;
};

const StatCard = ({ label, value, className = '' }: StatCardProps) => (
  <Stack className={cn('w-1/3 bg-seapoint-gray-background-modal p-4', className)}>
    <div className="text-xs font-thin leading-[22px] tracking-[-0.02em] text-seapoint-gray-text">{label}</div>
    <div className="text-base font-medium leading-[22px] tracking-[-0.02em]">{value}</div>
  </Stack>
);

export type Metric = {
  label: string;
  value: string | number;
};

type VendorTransactionsSummaryProps = {
  metrics: Metric[];
  className?: string;
};

export const VendorTransactionsSummary = ({ metrics, className = '' }: VendorTransactionsSummaryProps) => {
  return (
    <div className={cn('flex w-full justify-between gap-[1px]', className)}>
      {metrics.map((metric, index) => (
        <StatCard
          key={metric.label}
          label={metric.label}
          value={metric.value}
          className={cn(index === 0 && 'rounded-l-lg', index === metrics.length - 1 && 'rounded-r-lg')}
        />
      ))}
    </div>
  );
};
